import { HTMLAttributes } from 'react';
import clsx from 'clsx';
import { sportColor } from '@/lib/sportColors';

interface SportBadgeProps extends HTMLAttributes<HTMLSpanElement> {
  identifier?: string | null;
  label?: string | null;
}

const SportBadge = ({ identifier, label, className, ...props }: SportBadgeProps) => (
  <span
    className={clsx(
      'inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-semibold text-gray-800',
      className
    )}
    style={{ backgroundColor: sportColor(identifier) }}
    {...props}
  >
    {label || identifier || '—'}
  </span>
);

export default SportBadge;
